module.exports = __webpack_public_path__ + "img/custom-sources.353d67c1.png";